import { Operation, Resource, Role, ROLES } from '../common/constants';
import { GetMe_me_permissions } from '../graphql/user/types/GetMe';
import { parsePhoneNumber } from 'libphonenumber-js';

export const containsAll = (arr1: any[], arr2: any[]) =>
  arr2.every((arr2Item) => arr1.includes(arr2Item));

export const sameArrays = (arr1: any[], arr2: any[]) =>
  containsAll(arr1, arr2) &&
  containsAll(arr2, arr1) &&
  arr1.length === arr2.length;

export const canUser = (
  operation: Operation | null | undefined,
  resource: Resource | null | undefined,
  permissions: (GetMe_me_permissions | null)[] | null,
) =>
  !!permissions?.some(
    (permission) =>
      permission?.resource === resource &&
      ((operation === Operation.CREATE && !!permission?.create) ||
        (operation === Operation.READ && !!permission?.read) ||
        (operation === Operation.UPDATE && !!permission?.update) ||
        (operation === Operation.DELETE && !!permission?.delete) ||
        (operation === Operation.IMPORT && !!permission?.import) ||
        (operation === Operation.EXPORT && !!permission?.export)),
  );

export const formatPhoneNumber = (number: string | null | undefined) => {
  const parsedPhoneNumber = number ? parsePhoneNumber(number) : undefined;

  return parsedPhoneNumber ? parsedPhoneNumber.formatInternational() : '';
};

export const formatRoles = (roles: string | string[]): string => {
  if (typeof roles === 'string') {
    return ROLES[roles] ?? roles;
  } else {
    return roles?.reduce((text, role, index) => {
      if (index !== 0 && text) {
        text += ', ';
      }
      text += ROLES[role];
      return text;
    }, '');
  }
};

export const agencyAdressByRole = (rolesArray: string[]) => {
  const rolesArrayString = rolesArray.join(', ');
  if (rolesArrayString.includes(Role.NOTARY)) {
    return "Adresse de l'étude";
  }
  if (rolesArrayString.includes(Role.ESTATE_OFFICIER)) {
    return "Adresse de l'enseigne";
  }
  return " Adresse de l'agence";
};
